import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Col, Row, Form, Button} from 'react-bootstrap';
import StudentCourseService from '../../../service/studentCourseService';
import ReactTooltip from 'react-tooltip';
import useToken from '../../../App/useToken';
import 'react-toastify/dist/ReactToastify.css';
import './StudentCourse.css';

function EditStudentCourse() {
  const { getToken, getRole } = useToken();
  const { id } = useParams();
  const token = getToken();
  const role = getRole();
  const [score, setScore] = useState();
  const [fullName, setFullName] = useState();
  const [citizenId, setCitizenId] = useState();
  const [seniorOfRank, setSeniorOfRank] = useState();
  const [unit, setUnit] = useState('-');
  const [age, setAge] = useState();
  const [eclScore, setEclScore] = useState();
  const [unitScore, setUnitScore] = useState('-');
  const [lineScore, setLineScore] = useState('-');
  const [adminScore, setAdminScore] = useState('-');

  const setResponse = (data) => {
    if (data.name) {
      setFullName(`${data.rank}${data.name} ${data.surname}`);
      setSeniorOfRank(data.seniorOfRank);
      setUnit(data.unit);
      setCitizenId(data.citizenId);
      setAge(data.age);
      setEclScore(data.seniorOfRank);
      setUnitScore(data.unitScore);
      setLineScore(data.lineScore);
      setAdminScore(data.adminScore);
    }
  }

  const getStudentCourseInfo = async () => {
    const studentCourseService = new StudentCourseService();
    const res = await studentCourseService.getStudentCourseById(id, token);
    setResponse(res);
  }

  useEffect(() => {
    getStudentCourseInfo();
  }, []);

  const handleSubmitScore = async () => {
    const studentCourseService = new StudentCourseService();
    const res = await studentCourseService.updateStudentCourseScoreById(id, { score, role }, token);
    setResponse(res);
  }



  return (
    <div>
      <Container className='student-wrapper'>
        <ReactTooltip />
        <Row>
            <Col lg={12}>
              <Row style={{ height: '45px' }} className={ window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3}>{fullName}</Col>
                <Col className='background-border' lg={3}>เหล่า:</Col>
                <Col className='background-border' lg={3}>ระยะเวลาครองยศปัจจุบัน: {seniorOfRank}</Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3}>อายุ: {age}</Col>
                <Col className='background-border' lg={3}>ลชทอ.หลัก: </Col>
                <Col className='background-border' lg={3}>ระบุแผนอัตราการเข้าของหน่วย: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3}>ตำแหน่ง:</Col>
                <Col className='background-border' lg={3}>ลชทอ.รอง1: </Col>
                <Col className='background-border' lg={3}>คะแนนประเมินล่าสุด: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3}>สังกัด: {unit}</Col>
                <Col className='background-border' lg={3}>ลชทอ.รอง2: </Col>
                <Col className='background-border' lg={3}>ผลสอบภาษาอังกฤษ: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3}>สายวิทยาการ:</Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3}>คะแนนประเมินหน่วย: {unitScore}</Col>
                <Col className='background-border' lg={3}>คะแนนประเมินสาย: {lineScore}</Col>
                <Col className='background-border' lg={3}>คะแนนประเมินสาย กพ.ทอ.: {adminScore}</Col>
              </Row>
              <Row className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='import-file-container' lg={3} md={10} sm={12}>
                  <Form onSubmit={handleSubmitScore}>
                    <Form.Group as={Col} controlId="ecl">
                      <Form.Label>คะแนน</Form.Label>
                      <Form.Control  type="number" min='0' max='100' onChange={e => setScore(e.target.value)} />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Button variant="success btn-sm" type="submit">
                          บันทึก
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
      </Container>
    </div>
  )
};


export default EditStudentCourse;
